import React from 'react';

const services = [
  {
    title: 'Bulk Order Discounts',
    description:
      'Bulk orders receive better pricing, making large-volume purchasing more cost-effective for distributors, wholesalers, and retail partners.',
  },
  {
    title: 'Worldwide Shipping',
    description:
      'We support worldwide shipping with dependable dispatch planning, secure packaging, and clear coordination for domestic and international deliveries.',
  },
  {
    title: 'Export Support',
    description:
      'We handle export-focused supply requirements for spices, herbal powders, and dry fruits, with practical support for recurring international orders.',
  },
  {
    title: 'Lab Reports and Certificates',
    description:
      'Lab reports and relevant product certificates can be provided to support quality verification, compliance discussions, and buyer confidence.',
  },
  {
    title: 'Custom Packing Options',
    description:
      'We can support suitable packing options for different order sizes and business needs, helping products reach buyers in good condition.',
  },
  {
    title: 'Direct Business Assistance',
    description:
      'Buyers get direct communication for quotations, product selection, order coordination, and after-order support without unnecessary delays.',
  },
];

function ServicesSection() {
  return (
    <section className="tab-panel services-panel">
      <span className="home-eyebrow">We Offer</span>
      <h2 className="tab-panel-title">Reliable supply services for wholesale and export buyers.</h2>
      <p className="tab-panel-text services-intro">
        We support growing businesses with quality-focused sourcing, responsive communication,
        export-ready coordination, and practical order support from inquiry to dispatch.
      </p>

      <div className="services-grid">
        {services.map((service) => (
          <article key={service.title} className="service-card">
            <h3 className="service-card-title">{service.title}</h3>
            <p className="service-card-text">{service.description}</p>
          </article>
        ))}
      </div>
    </section>
  );
}

export default ServicesSection;
